import React from "react";
import ImageDisplayer from "./ImageDisplayer";
import { motion } from "motion/react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import bakedGoatCheese from "food_pictures/menu/baked-goat-cheese.jpg";
import calamari from "food_pictures/menu/calamari.jpg";
import insalataCaprese from "food_pictures/menu/insalata-caprese.jpg";
import walnutGorgonzola from "food_pictures/menu/walnut-gorgonzola.jpg";
import angelHair from "food_pictures/menu/angel-hair.jpg";
import pappardelle from "food_pictures/menu/pappardelle.jpg";
import rigatoniPrimavera from "food_pictures/menu/rigatoni-primavera.jpg";
import zitiPrimavera from "food_pictures/menu/ziti-primavera.jpg";
import bakedRigatoni from "food_pictures/menu/baked-rigatoni.jpg";
import asiagoStuffedGnocchi from "food_pictures/menu/asiago-stuffed-gnocchi.jpg";
import florentine from "food_pictures/menu/florentine.jpg";
import meatballs from "food_pictures/menu/meatballs.jpg";
import organicPetiteChicken from "food_pictures/menu/organic-petite-chicken.jpg";
import lambShank from "food_pictures/menu/lamb-shank.jpg";
import grilledNewYorkStripSteak from "food_pictures/menu/grilled-new-york-strip-steak.jpg";
import cioppino from "food_pictures/menu/cioppino.jpg";
import tiramisu from "food_pictures/menu/tiramisu.jpg";
import moltenChocolateCake from "food_pictures/menu/molten-chocolate-cake.jpg";
import hazelnutPearTart from "food_pictures/menu/hazelnut-pear-tart.jpg";
import bruschetta from "food_pictures/menu/bruschetta.jpg";
import mussels from "food_pictures/menu/mussels.jpg";
import grilledOctopus from "food_pictures/menu/grilled-octopus.jpg";
import mixedGreens from "food_pictures/menu/mixed-greens.jpg";
import conchiglietti from "food_pictures/menu/conchiglietti.jpg";
import farfalleWithChicken from "food_pictures/menu/farfalle-with-chicken.jpg";
import spinachGnocchi from "food_pictures/menu/homemade-spinach-gnocchi.jpg";
import linguineMarinara from "food_pictures/menu/linguine-marinara.jpg";
import linguineClamsMussels from "food_pictures/menu/linguine-with-clams-and-mussels.jpg";
import tortelliniDellaNonna from "food_pictures/menu/tortellini-della-nonna.jpg";
import grilledSalmon from "food_pictures/menu/grilled-salmon.jpg";
import cremeBrulee from "food_pictures/menu/limoncello-creme-brulee.jpg";
import demiPizza from "food_pictures/menu/demi.jpg";
import genoaPizza from "food_pictures/menu/genoa.jpg";
import seatingLanding from "images/SeatingLandingCompressed.jpg";
import fallStorefront from "images/gallery/fall-storefront.jpg";
import fallPatioTable from "images/gallery/fall-patio-table.jpg";
import fallPastaTwirl from "images/gallery/fall-pasta-twirl.jpg";
import fallPatioSpread from "images/gallery/fall-patio-spread.jpg";
import fallPatioFront from "images/gallery/fall-patio-front.jpg";
import foodLanding from "images/FoodLandingCompressed.jpg";
import inActionFood from "images/InActionFoodCompressed.jpg";
import "./Gallery.css";
import { fadeInMany } from "animations";

function GalleryPopulator() {
  const pictures = [
    { file: fallStorefront, key: "fall-storefront" },
    { file: bakedGoatCheese, name: "Baked Goat Cheese" },
    { file: bruschetta, name: "Bruschetta" },
    { file: calamari, name: "Calamari" },
    { file: seatingLanding, key: "window-table" },
    { file: mussels, name: "Mussels" },
    { file: grilledOctopus, name: "Grilled Octopus" },
    { file: insalataCaprese, name: "Insalata Caprese" },
    { file: fallPatioTable, key: "fall-patio-table" },
    { file: mixedGreens, name: "Mixed Greens" },
    { file: walnutGorgonzola, name: "Walnut Gorgonzola" },
    { file: angelHair, name: "Angel Hair" },
    { file: pappardelle, name: "Pappardelle" },
    { file: fallPastaTwirl, key: "fall-pasta-twirl" },
    { file: rigatoniPrimavera, name: "Rigatoni Primavera" },
    { file: conchiglietti, name: "Conchiglietti" },
    { file: foodLanding, key: "table-spread" },
    { file: farfalleWithChicken, name: "Farfalle with Chicken" },
    { file: zitiPrimavera, name: "Ziti Primavera" },
    { file: spinachGnocchi, name: "Homemade Spinach Gnocchi" },
    { file: bakedRigatoni, name: "Baked Rigatoni" },
    { file: fallPatioSpread, key: "fall-patio-spread" },
    { file: asiagoStuffedGnocchi, name: "Asiago Stuffed Gnocchi" },
    { file: linguineMarinara, name: "Linguine Marinara" },
    { file: linguineClamsMussels, name: "Linguine with Clams and Mussels" },
    { file: tortelliniDellaNonna, name: "Tortellini della Nonna" },
    { file: demiPizza, name: "Demi Pizza" },
    { file: florentine, name: "Florentine" },
    { file: genoaPizza, name: "Genoa Pizza" },
    { file: meatballs, name: "Meatballs" },
    { file: inActionFood, key: "pasta-pull" },
    { file: organicPetiteChicken, name: "Organic Petite Chicken" },
    { file: lambShank, name: "Lamb Shank" },
    { file: grilledNewYorkStripSteak, name: "Grilled New York Strip Steak" },
    { file: fallPatioFront, key: "fall-patio-front" },
    { file: cioppino, name: "Cioppino" },
    { file: grilledSalmon, name: "Grilled Salmon" },
    { file: tiramisu, name: "Tiramisu" },
    { file: moltenChocolateCake, name: "Molten Chocolate Cake" },
    { file: hazelnutPearTart, name: "Hazelnut Pear Tart" },
    { file: cremeBrulee, name: "Limoncello Crème Brulee" },
  ];

  return (
    <div className="gallery-container">
      <ResponsiveMasonry columnsCountBreakPoints={{ 700: 1, 750: 2 }}>
        <Masonry gutter="15px">
          {pictures.map((image, index) => (
            <motion.div
              key={image.name || image.key}
              custom={index}
              initial="hidden"
              animate="visible"
              variants={fadeInMany}
            >
              <ImageDisplayer pic={image.file} name={image.name} />
            </motion.div>
          ))}
        </Masonry>
      </ResponsiveMasonry>
    </div>
  );
}

export default GalleryPopulator;
